import React from "react"

const LanguageFlag = ({ languageCode, size = 32, className = "", ...props }) => {
  const getFlagPath = code => {
    try {
      return require(`../../ressource/svg/flags/${code}.svg`)
    } catch (error) {
      return null
    }
  }

  const flagPath = getFlagPath(languageCode)

  if (!flagPath) {
    return (
      <div className={`language-flag-fallback language-flag--large ${className}`} data-testid="language-flag-fallback" {...props}>
        {languageCode ? languageCode.toUpperCase() : ""}
      </div>
    )
  }

  return <img src={flagPath} alt={`Flag of ${languageCode}`} className={`language-flag language-flag--large ${className}`} />
}

export default LanguageFlag
